'use client';

import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import { getStaticAssetUrl } from '@/app/lib/utils/static-asset-url';

export default function SimulaixTerraDemo() {
    const { t } = useTranslation('simulaix-terra-demo');
    return (
        <section className="relative flex w-full flex-col items-center overflow-hidden bg-black text-white">
            {/* Content Container */}
            <div className="tablet:max-w-[800px] desktop:max-w-[1360px] relative z-10 flex w-[87.5vw] max-w-[480px] flex-col items-center">
                {/* Logo Combination */}
                <div className="tablet:pt-[100px] desktop:pt-[120px] tablet:pb-[16px] tablet:justify-center relative flex w-full flex-none justify-start pb-[8px] pt-[80px]">
                    <Image
                        src={getStaticAssetUrl(
                            '/home/icon-simulaix-terra.webp',
                        )}
                        alt="Simulaix & Terra"
                        width={400}
                        height={60}
                        className="tablet:w-[400px] desktop:[526px] h-auto w-[220px] object-contain"
                        priority
                    />
                </div>

                <div className="j-h4 tablet:j-h2 tablet:t ext-center tablet:items-center flex w-full   flex-col items-start text-start">
                    {/* Title */}
                    <p className="tablet:text-center text-start tracking-wide">
                        {t('title.part1')}
                    </p>

                    <p className="tablet:pb-[60px] desktop:pb-[80px] bg-[linear-gradient(90deg,#F7A1FF,#7AAFFF)] bg-clip-text pb-[40px] text-transparent">
                        {t('title.part2')}
                    </p>
                </div>

                {/* Dashboard Image Container 
                    It is designed to be truncated because the section is h-screen. 
                    Using flex-1 ensures it pushes to the bottom of the screen.
                */}
                <div className="relative flex w-full items-start justify-center">
                    {/* 彩色模糊光晕层 */}
                    <div
                        style={{
                            background:
                                'linear-gradient(90deg, #c1b1ed 0%, #7f62d3 23.5%, #537cf7 53.15%, #e356fd 77.87%, #fbde7a 100%)',
                        }}
                        className="pointer-events-none absolute -inset-[2px] rounded-[14px] opacity-60 blur-[18px]"
                    />
                    <Image
                        src={getStaticAssetUrl('/home/img-simulaix-demo.webp')}
                        alt="Simulaix Demo Interface"
                        width={1040}
                        height={900}
                        className="relative z-10 h-auto w-full object-contain drop-shadow-[0_0_24px_rgba(255,255,255,0.1)]"
                    />
                </div>
            </div>
        </section>
    );
}
